import CargaTramite from "../views/sandbox/CargaTramite.vue";
import CargaTramiteSandbox from "../views/sandbox/CargaTramitePruebas.vue";

export default [
  {
    path: "/carga-tramite",
    name: "CargaTramite",
    component: CargaTramite,
  },
  {
    path: "/carga-tramite-sandbox",
    name: "CargaTramiteSandbox",
    component: CargaTramiteSandbox,
  },
];
